import GaugeChart from "react-gauge-chart";

export const CostumGaugeChart = (props) => {
    return(
        <div style={{width: '40%', heigth: 'auto'}}>
            <GaugeChart id="gauge-chart1" 
                nrOfLevels={props.nrOfLevels} 
                colors={props.colors} 
                arcWidth={0.3} 
                percent={(props.value * 100 / 10) / 100}//Necessery /100 because the percentage it's a value between 0 and 1
                hideText={true}
                arcsLength={props.arcsLength}
                cornerRadius={0}
                arcPadding={0.02}
            />
        </div>
    )
}